var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.record.output)?_c('v-badge',{staticClass:"ml-2",attrs:{"color":"black","content":_vm.content,"inline":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }